import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetImagesRequestModel, GetImagesResponseModel } from "@/features/accounts/ocr/services/get-images-model";

export class GetImagesApi {
  /**
   * OCR取込ファイル表示API
   */
  public GetImages = async (
    param: GetImagesRequestModel
  ): Promise<GetImagesResponseModel[]> => {
    const path = `/api/ocraccounts/images`;

    const res = await ApiClient.instance.get<GetImagesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
